module.exports = __webpack_public_path__ + "img/イノフェス_talksession_nft_企画書_ページ_3.b8ef15cf.png";